export const PLAYER_COLORS = [
  "#B4532F",
  "#D9A441",
  "#6E8B5E",
  "#C77B9E",
  "#7B9EA8",
  "#8A7A64",
  "#4A6FA5",
  "#A85751",
]

export const TOO_HIGH = "over"

const CODE_WORDS = [
  "PLUM",
  "MANGO",
  "PEACH",
  "LEMON",
  "KIWI",
  "GRAPE",
  "APPLE",
  "BERRY",
  "MELON",
  "OLIVE",
  "PECAN",
  "MAPLE",
  "CEDAR",
  "RIVER",
  "STONE",
  "CLOUD",
  "STORM",
  "FROST",
  "EMBER",
  "SPARK",
  "TIGER",
  "OTTER",
  "GOOSE",
  "MOOSE",
  "BISON",
  "ROBIN",
  "FINCH",
  "GECKO",
  "KOALA",
  "LLAMA",
  "ZEBRA",
  "PANDA",
  "COMET",
  "NOVA",
  "LUNAR",
  "SOLAR",
  "DELTA",
  "ECHO",
  "TANGO",
  "RUMBA",
]

export function generateRoomCode(rand = Math.random) {
  const word = CODE_WORDS[Math.floor(rand() * CODE_WORDS.length)]
  const num = 10 + Math.floor(rand() * 90)
  return `${word}-${num}`
}

export function buildSlots(guesses) {
  const byValue = new Map()
  Object.entries(guesses || {}).forEach(([pid, value]) => {
    if (!byValue.has(value)) byValue.set(value, [])
    byValue.get(value).push(pid)
  })
  const values = [...byValue.keys()].sort((a, b) => a - b)
  const isEven = values.length % 2 === 0
  const mid = (values.length - 1) / 2
  return values.map((value, i) => {
    const dist = Math.abs(i - mid)
    const baseOdds = isEven ? 3 : 2
    return {
      value,
      playerIds: byValue.get(value),
      odds: baseOdds + Math.floor(dist),
    }
  })
}

export function tooHighOdds(slots) {
  if (!slots.length) return 6
  return Math.max(...slots.map((s) => s.odds)) + 2
}

export function resolveWinningSlot(slots, answer) {
  let winning = TOO_HIGH
  slots.forEach((slot, i) => {
    if (slot.value <= answer) winning = i
  })
  return winning
}

export function computePayouts({ guesses, bets }, answer) {
  const slots = buildSlots(guesses)
  const winning = resolveWinningSlot(slots, answer)
  const winOdds = winning === TOO_HIGH ? tooHighOdds(slots) : slots[winning].odds
  const deltas = {}
  const add = (pid, n) => {
    deltas[pid] = (deltas[pid] || 0) + n
  }
  const winnerIds = winning === TOO_HIGH ? [] : [...slots[winning].playerIds]
  winnerIds.forEach((pid) => add(pid, 3))
  Object.entries(bets || {}).forEach(([pid, placed]) => {
    ;(placed || []).forEach((b) => {
      const primary = b.primary !== undefined ? b.primary : (b.chips || 0)
      const stacked = b.stacked || 0
      if (b.slot === winning) {
        add(pid, (primary + stacked) * winOdds)
      } else if (stacked > 0) {
        add(pid, -stacked)
      }
    })
  })
  return { slots, winning, winOdds, winnerIds, deltas }
}

export function shuffle(array, rand = Math.random) {
  const out = [...array]
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1))
    ;[out[i], out[j]] = [out[j], out[i]]
  }
  return out
}
